window.$ = require('jquery');
require('./modernizr.js');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
var magnificPopup = require('magnific-popup');
var fitvids = require('fitvids');

import '@babel/polyfill';
import './vanilla/eventPolyfill';
import { initializeReact } from './react';
import { initHeaderFixed } from './vanilla/siteHeader';
import { initVideoModals } from './vanilla/videos';
import { initLinks } from './vanilla/links';

jQueryBridget('flickity', Flickity, $);

$(document).ready(function () {
	initMobileNav();
	initHeaderFixed();
	initAccordions();
	initCarousels();
	initCloseAnnoucement();
	initVideoModals();
	initJumpMenu();
	initFixedSidebar();
	initFlipTiles();
	initializeReact();
	initLinks();
});

// FitVids
fitvids('.wysiwyg-content');
fitvids('.generic-video');

// HEADER NAV // DROPDOWNS
function initMobileNav() {

	$('.site-header__mobile-toggle').on('click', function () {
		$(this).siblings('.site-header__nav-list').toggleClass('active');
		$(this).toggleClass('active');
		$('body').toggleClass('fixed');
	});

	$('.site-header__nav-sub-menu--overview, .site-header__nav-sublist-item, .site-header__nav-list-item--search, .site-header__nav-list-item:not(.site-header__nav-list-item--has-children)').on('click', function (e) {
		e.stopPropagation();
	});

	// touch-based nav toggles
	$('.touchevents header nav.site-header__nav ul li.site-header__nav-list-item--has-children > a').click(function (e) {
		e.preventDefault();
		let navMenuParent = $(this).parent();
		let navMenu = $(this);
		let navMenuDropdown = $(this).next('.site-header__nav-sublist');
		if (!navMenuParent.hasClass('site-header__nav-list-item--active')) {
			$('.touchevents header nav.site-header__nav ul li.site-header__nav-list-item--has-children').removeClass('site-header__nav-list-item--active').closest('.site-header__nav-sublist').show();
			navMenuParent.attr('aria-expanded', 'true');
			navMenuParent.addClass('site-header__nav-list-item--active');
			navMenuDropdown.show().attr('aria-hidden', 'false');
		} else {
			navMenuParent.removeClass('site-header__nav-list-item--active').closest('.site-header__nav-sublist').hide();
			navMenuParent.attr('aria-expanded', 'false');
			navMenuDropdown.hide().attr('aria-hidden', 'true');
		}

		$(document).on('keyup', function (e) {
			if (e.key === 'Escape') {
				navMenuParent.removeClass('site-header__nav-list-item--active').closest('.site-header__nav-sublist').hide();
			}
		});
	});

	// touch-based member profile toggle
	$('.touchevents header .site-header__user-menu .site-header__user-menu__btn').click(function (e) {
		e.preventDefault();
		let memberMenuParent = $(this).parent();
		let memberMenu = $(this);
		let memberMenuDropdown = $(this).next('.site-header__user-menu__dropdown');
		if (!memberMenuParent.hasClass('site-header__user-menu--active')) {
			memberMenuParent.removeClass('site-header__user-menu--active').closest('.site-header__user-menu__dropdown').show();
			memberMenuParent.attr('aria-expanded', 'false');
			memberMenuParent.addClass('site-header__user-menu--active');
			memberMenuDropdown.show().attr('aria-hidden', 'false');
		} else {
			memberMenuParent.removeClass('site-header__user-menu--active').closest('.site-header__user-menu__dropdown').hide();
			memberMenuParent.attr('aria-expanded', 'true');
			memberMenuDropdown.hide().attr('aria-hidden', 'true');
		}

		$(document).on('keyup', function (e) {
			if (e.key === 'Escape') {
				memberMenuParent.removeClass('site-header__user-menu--active').closest('.site-header__user-menu__dropdown').hide();
			}
		});
	});
}

// ACCORDIONS
function initAccordions() {
	if ($('.accordion__toggle').length > 0) {
		$('.accordion__toggle').on('click', function (e) {
			e.preventDefault();
			let target = $(this).attr('href');
			if ($(this).hasClass('accordion__toggle--active')) {
				$(this)
					.removeClass('accordion__toggle--active')
					.attr('aria-expanded', 'false');
				$(target)
					.slideUp()
					.attr('aria-hidden', 'true');
			} else {
				$(this)
					.addClass('accordion__toggle--active')
					.attr('aria-expanded', 'true');
				$(target)
					.slideDown()
					.attr('aria-hidden', 'false');
			}
		});
	}
}

// CAROUSELS
function initCarousels() {
	// testimonial carousel
	$('.testimonial-carousel__carousel').flickity({
		prevNextButtons: true,
		draggable: true,
		adaptiveHeight: true,
		groupCells: true,
		pageDots: true,
		cellAlign: 'left'
	});

	// generic page carousel
	$('.page-carousel__carousel').flickity({
		prevNextButtons: true,
		draggable: true,
		adaptiveHeight: true,
		groupCells: false,
		pageDots: true
	});

	// cards carousel ex. additional jobs
	$('.cards-carousel__carousel').flickity({
		prevNextButtons: true,
		draggable: true,
		adaptiveHeight: true,
		groupCells: false,
		pageDots: false,
		cellAlign: 'left'
	});
}

// ANNOUNCEMENT - CLOSE BTN
function initCloseAnnoucement() {
	if ($('.page-announcement__close').length > 0) {
		$('.page-announcement__close').click(function (e) {
			e.stopPropagation();
			e.preventDefault();
			$('#close-announcement').hide();
		});
	}
}

// FIXED SIDEBARS (pages' subnav, event detail)
function initFixedSidebar() {
	// Global Function - Determine if an element is in the viewport
	$.fn.isOnScreen = function () {
		let win = $(window);
		let viewport = {
			top: win.scrollTop(),
			left: win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();
		let bounds = this.offset();
		bounds.right = bounds.left + this.outerWidth();
		bounds.bottom = bounds.top + this.outerHeight();
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};

	// Event sidebar fixed to left side on scroll
	if ($('.event--content').length > 0) {

		let eventContentTopPosition = $('.event--content').position();
		let eventTitleHeight = $('.event-header').height();
		let eventIntroHeight = $('.page-intro').height() ? 0 : 0;
		let eventAnnoucementHeight = $('.event-announcement').height() ? 0 : 0;
		let eventOffsetPosition = parseInt(eventContentTopPosition.top) + parseInt(eventTitleHeight) + parseInt(eventIntroHeight) + parseInt(eventAnnoucementHeight);

		$(window).scroll(function () {

			// Add fixed class on scroll
			if (window.screen.width >= 768) {
				if ($(window).scrollTop() >= eventOffsetPosition) {
					$('.event--content.sidebar-behavior-fixed').addClass('fix-on-scroll');
				} else {
					$('.event--content.sidebar-behavior-fixed').removeClass('fix-on-scroll');
				}
			} else {
				$('.event--content.sidebar-behavior-fixed').removeClass('fix-on-scroll');
			}

			// FadeOut/In fixed sidebar if the footer is in the viewport (event detail)
			if ($('.events-similar').length > 0) {
				if ($('.events-similar').isOnScreen()) {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeOut();
				} else {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeIn();
				}
			} else if ($('.events-similar').length > 0) {
				if ($('.page-cta').isOnScreen()) {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeOut();
				} else {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeIn();
				}
			} else {
				if ($('footer').isOnScreen()) {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeOut();
				} else {
					$('.event--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-anchors').fadeIn();
				}
			}
		});

	}

	// Generic subnav sidebar fixed to left side on scroll
	if ($('.coordinates--content').length > 0) {

		// Get the position of this div.
		let coordContentTopPosition = $('.coordinates--content').position();
		let pageTitleHeight = $('.page-title').height() ? 0 : 0;
		let pageIntroHeight = $('.page-intro').height() ? 0 : 0;
		let pageJobHeader = $('.header-job').height() ? 0 : 0;
		let pageCommitteeHeader = $('.header-committee').height() ? 0 : 0;
		let pageDisclaimer = $('.page-disclaimer').height() ? 0 : 0;
		let pageBreadcrumbs = $('.breadcrumbs').height() ? 0 : 0;
		let pageOffsetPosition = parseInt(coordContentTopPosition.top) + parseInt(pageTitleHeight) + parseInt(pageIntroHeight) + parseInt(pageJobHeader) + parseInt(pageCommitteeHeader) + parseInt(pageDisclaimer) + parseInt(pageBreadcrumbs);

		$(window).scroll(function () {

			// Add fixed class on scroll
			if (window.screen.width >= 768) {
				if ($(window).scrollTop() >= pageOffsetPosition) {
					$('.coordinates--content.sidebar-behavior-fixed').addClass('fix-on-scroll');
				} else {
					$('.coordinates--content.sidebar-behavior-fixed').removeClass('fix-on-scroll');
				}
			} else {
				$('.coordinates--content.sidebar-behavior-fixed').removeClass('fix-on-scroll');
			}

			// FadeOut/In fixed sidebar if the footer is in the viewport (ie: leadership)
			// Generic Pages check if cta exists
			if ($('.page-cta').length > 0) {
				if ($('.page-cta').isOnScreen()) {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeOut();
				} else {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeIn();
				}
				//	Job Detail check if additional jobs exists
			} else if ($('.cards-carousel').length > 0) {
				if ($('.cards-carousel').isOnScreen()) {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeOut();
				} else {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeIn();
				}
			} else {
				if ($('footer').isOnScreen()) {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeOut();
				} else {
					$('.coordinates--content.sidebar-behavior-fixed.fix-on-scroll .nav__sidebar-subnav').fadeIn();
				}
			}

		});
	}
}

// JUMP MENU - SMOOTH SCROLLING
function initJumpMenu() {
	if ($('.nav__sidebar-anchors').length > 0) {
		$("a.nav__sidebar-anchors__list-item-link[href*='#']").bind('click', function (e) {
			e.preventDefault();

			let anchorTarget = $(this).attr('href');
			if ($(anchorTarget).length > 0) {
				$('html, body').stop().animate({
					scrollTop: $(anchorTarget).offset().top
				}, 600, function () {
					location.hash = anchorTarget;
				});
			}

			return false;

		});

		$(window).scroll(function () {
			$('.section--anchor').each(function (i, header) {
				let anchorHeader = header.getBoundingClientRect();
				if (anchorHeader.top <= 160) {
					$('a.nav__sidebar-anchors__list-item-link.link--active').removeClass('link--active');
					$('a[href="#' + header.id + '"]').addClass('link--active');
				}
			});
		}).scroll();
	}
}

// LOGO GRID/TILES - EVENT DETAIL
function initFlipTiles() {
	if ($('.logo-grid').length > 0) {
		$('.logo-grid__tile').each(function () {
			$('.logo-grid__tile > .logo-grid__logo-front').on('click', function () {
				$(this).parent().addClass('logo-grid--open');
				$(this).attr('aria-pressed', 'true');
			});

			$('.logo-grid__close').on('click', function () {
				$(this).closest('.logo-grid__tile.logo-grid--open').removeClass('logo-grid--open');
				$(this).parent().prev('.logo-grid__logo-front').attr('aria-pressed', 'false');
			});
		});
	}
}
